export const testPhone = (value: string) => {
  return /^1[3-9][0-9]{9}$/.test(value);
};

export const testID = (value: string) => {
  return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
    value,
  );
};
